import { render } from "./df-withdraw.vue?vue&type=template&id=9384a804&scoped=true"
import script from "./df-withdraw.vue?vue&type=script&lang=js"
export * from "./df-withdraw.vue?vue&type=script&lang=js"

import "./df-withdraw.vue?vue&type=style&index=0&id=9384a804&scoped=true&lang=css"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9384a804"]])

export default __exports__